import { useDispatch } from "react-redux";
import { Button, Radio } from "@mui/material";
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useState, useEffect } from "react";
import _ from "lodash";
import { editDepot } from "src/thunks/depotUsers";
import toastMessages from "src/constant/toastMessages.json";
import { GetError } from "src/constant";
import { getAllNofificationForDashboard } from "src/thunks/dashboard";

export const AllocatToDepo = ({ selectedData, toggleHandler, handleViewRecordButtonClick }) => {

      /** redux store useDispatch & useSelector ------------------------------ **/
      const dispatch = useDispatch();
      const depoData = useSelector((state) => state?.depotUsers?.depoData || []);

      /** hooks useState ----------------------------------------------------- **/
      const [selectDepot, _selectDepot] = useState("");
      const [currentAllocatedDepots, setCurrentAllocatedDepots] = useState([])
      const [depotShown, setDepotsShown] = useState([])

      /** hooks useEffect----------------------------------------------------- **/
      useEffect(() => {
            const newData = _.filter(selectedData?.depots || [], (d1) => d1.hasAllocated === true) || "";
            setCurrentAllocatedDepots([...newData])
      }, [selectedData])


      /** UseEffect used to filter depots which are already added ----------------------- **/
      useEffect(() => {
            if (currentAllocatedDepots?.length > 0) {
                  const idsToRemove = currentAllocatedDepots?.map(depot => depot.id);
                  const filteredArray = depoData.filter(item => !idsToRemove.includes(item.id));
                  setDepotsShown([...filteredArray])
            } else {
                  setDepotsShown([...depoData])
            }
      }, [currentAllocatedDepots])


      /** handler functions--------------------------------------------------- **/

      /** Function executes when clicking on 'Allocate Depot'. ------------------ **/
      const handleAllocateDepotClick = async () => {
            const oldDepotUsers = selectDepot?.depotUsers?.map((item, index) => {
                  return {
                        userId: item.userId,
                  };
            });
            const concatenatedArray = [...oldDepotUsers, { userId: selectedData?.id }];
            let model = {
                  "id": selectDepot?.id,
                  "name": selectDepot?.name,
                  "code": selectDepot?.code,
                  "address": {
                        "street1": selectDepot?.address?.street1 || "",
                        "country": selectDepot?.address?.country || "",
                        "city": selectDepot?.address?.city || "",
                        "zip": selectDepot?.address?.zip || "",
                  },
                  "internalArea": selectDepot?.internalArea || 0,
                  "externalArea": selectDepot?.externalArea || 0,
                  "depotUsers": concatenatedArray ? concatenatedArray : [],
                  "isParentResourceUpdated": false,
                  "NewAllocationManager": [{ ...selectedData }],
                  "allocateManager": true
            }
            try {
                  let result = await dispatch(editDepot({ data: model })).unwrap();
                  setTimeout(() => {
                        dispatch(getAllNofificationForDashboard(1, 20));
                  }, 2000);
                  if (result) {
                        toggleHandler(false);
                        handleViewRecordButtonClick();
                        toast.success(toastMessages.depotAllocated)
                  }

            } catch (err) {
                  toast.error(GetError(err?.response?.data?.errors) || "something issue");

            }

      }


      return <div>
            <div className="depot-form-header-style">
                  ALLOCATE DEPOT
                  <span style={{ paddingLeft: 20, color: "#FAB702" }}>{selectedData?.firstName} {selectedData?.lastName}</span>
            </div>
            <div style={{ paddingLeft: 200, paddingRight: 200 }}>
                  {currentAllocatedDepots?.length > 0 &&
                        <div style={{ marginTop: 10 }}>
                              <span className="currentlyat-text-style"> CURRENTLY AT  </span>
                              <span className="currenly-at-depotname-style ms-2">{currentAllocatedDepots?.map(item => item.name).join(' , ')}</span>
                        </div>
                  }
                  <div style={{ display: "flex", justifyContent: "center", paddingTop: 30 }}>
                        <div >
                              {[...depotShown].map((d, index) => {
                                    return <div key={index} style={{ display: "flex", paddingTop: 2, paddingBottom: 2, alignItems: "center" }} onClick={() => {
                                          if (selectDepot?.id === d?.id) {
                                                _selectDepot("");
                                          } else
                                                _selectDepot(d);
                                    }
                                    }>
                                          <Radio
                                                checked={d?.id === selectDepot?.id}
                                                sx={{
                                                      '& .MuiSvgIcon-root:not(.MuiSvgIcon-root ~ .MuiSvgIcon-root)': { color: '#0045D9', width: 30, height: 30 },
                                                      '& .MuiSvgIcon-root + .MuiSvgIcon-root': { color: '#0045D9', width: 30, height: 30 },
                                                }} />
                                          <span className="allocated-depotname-style">{d?.name}</span>
                                    </div>;
                              })}
                        </div>
                  </div>
            </div>
            {/* <div style={{ position: "absolute", bottom: 30, width: "100%" }}> */}
            <div style={{ bottom: 50, width: "100%", marginBottom: 30 }}>
                  <div style={{ paddingLeft: 90, paddingRight: 90 }}>
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                              <Button variant="outlined" className="btn-bootstrap-submit-style" style={{ color: "red", borderColor: "red" }} startIcon={<CancelIcon />} onClick={() => toggleHandler(false)}>
                                    Cancel
                              </Button>
                              <Button variant="outlined" className="btn-bootstrap-submit-style" startIcon={<CheckCircleIcon />} type="submit"
                                    // onClick={() => toggleHandler(false)}
                                    onClick={() => handleAllocateDepotClick()}

                              >
                                    Submit
                              </Button>
                        </div>
                  </div>
            </div>
      </div >;
}; 